import React from 'react';

import { PolicyCowbellFactorsPanel } from '../../../../../components/cowbellFactors/PolicyCowbellFactorsPanel';

/**
 * Policy details drawer → Cowbell Factors tab. Renders the shared
 * PolicyCowbellFactorsPanel; the locked/live toggle is owned by the drawer and
 * shared with the Organization Details tab.
 */
export const CowbellFactorsTab = ({ policy, latestRisk }: any) => {
  return (
    <PolicyCowbellFactorsPanel
      policy={policy}
      accountId={policy?.accountId}
      latestRisk={latestRisk}
      cardBackground="default"
    />
  );
};
